module.exports = __webpack_public_path__ + "static/media/night-active.1778cfb6.png";